<template>
	<div id="create-modal-for-schedule">
	<div class="scheduler scheduler-height" id="create-container-for-schedule">
		<div class="scheduler">
			<h1>Scheduler</h1>
		</div>
		<div>
			<h2>Period</h2>
			<p>Define a recurring period of time, by giving it a start date/time and a cycle duration. Note that this and all date/times are expressed in your current time zone, including DST if appropriate, but that DST adjustments will not automatically be made.</p>
			<p class="required warning"> Required fields</p>
			<p v-if="showDayLightSavingsText" class="warning">User will need to set cycle start date time one hour before to account for day light savings regardless of Country</p>
			<label class="required">Cycle Start Date</label>
			<input class="curved-border extra-padding-text-fields" id="schedule-start-picker" type="datetime-local" v-model="scheduleStartDate">
			<div>
				<label class="required">Cycle Duration</label>
				<input class="curved-border extra-padding-text-fields cycle-duration-width" title="Cycle Duration Number"  v-model="cycleDurationNumber" type="number">
				<select class="curved-border extra-padding-text-fields" v-model="cycleDurationUnit" title="Cycle Duration">
					<option value="Years">Years</option>
					<option value="Months">Months</option>
					<option value="Days">Days</option>
				</select>
			</div>
		</div>
		<div>
			<h2> Window definition</h2>
			<p>Define one or more windows of time within the period. The start is an offset of days + hours + etc. from the start of any given cycle. You can also select multiple days to be skipped past if, for instance, you need a "4th Thursday of November" type rule.<br>
				As a matter of convenience, you can use the date picker and button to find the offset for you.</p><br>
			 <p>Duration is just how long the window lasts, as a combination of days + hours + etc.</p><br>
			<div v-if="windows.length != 0" class="windows-div">
				<!-- <button class="btn" title="Remove Schedule" @click="removeWindow()">Remove Window</button> -->
				<label>Windows</label>
				<select class="curved-border extra-padding-text-fields windows-select" id="created-windows" title="Created Windows" v-model="windows" multiple> 
					<option class="disabled-input" v-for="(window,index) in windows" :id="`window-${index}`">{{ window }}</option>
				</select>
			</div>
		</div>
		<Schedule :scheduleStartDate="scheduleStartDate" :cycleDurationNumber="cycleDurationNumber" :cycleDurationUnit="cycleDurationUnit" :adminState="adminState"></Schedule>
		<div>
			<button class="btn create-button" @click="makeSchedule()">Create</button>
			<h2>Schedule Cycles</h2>
			<button class="btn" @click="closeScheduler()">Close</button>
		</div>
		<textarea class="curved-border extra-padding-text-fields textarea-input" id="displaySchedule">
		</textarea>
		<div v-if="calendarDataLoaded">
			<p class="warning">Calendar is not reflective of the accuracy of the months, Calendar is for visualization of the Schedule</p>
			<div  class="calendar-section">
				<MultiCalendar :cycleData="calendarData" :cycleDurationNumber="cycleDurationNumber" :cycleDurationUnit="cycleDurationUnit" :schedule="schedule"></MultiCalendar>
			</div>
		</div>
	</div>
</div>
</template>

<script>

import Calendar from "@/components/Calendar";
import Schedule from "@/components/Schedule";
import MultiCalendar from "@/components/MultiCalendar.vue";

export default {
	name: "Scheduler",
	components: {
		Calendar,
		Schedule,
		MultiCalendar
	},
	props: {
		adminState: Object
	},
	data() {
		return {
			windowOneStartDate: null,
			cycleDurationNumber: null,
			cycleDurationUnit: null,
			serverBusy: false,
			status: Object.assign({}, this.globalStatus),
			currScheduleAmount: 1,
			maxAmountOfSchedules: 3,
			cycleData:[],
			listOfCycles:[],
			calendarDataLoaded: false,
			// calendarOne: [],
			// calendarTwo: [],
			// calendarThree: [],
			calendarData:[],
			serializedData: "",
			schedule: null,
			scheduleStartDate: null,
			windows: [],
			currentWindow: 0,
			showDayLightSavingsText: false,
		};
	},
	mounted(){
		// this.eventBus.on("cycleDataForSchedule", (payload)=>{
		// 	this.cycleData = payload;
		// 	this.serializeData();
		// });
		this.eventBus.on("addWindow", (payload)=>{
			this.windows.push(payload);
			setTimeout(() => {
				document.getElementById("window-"+this.currentWindow).disabled = true;
				this.currentWindow++;
			}, 500);
		}); 

		let currYear = new Date().getFullYear();
		let secondSundayOfMarch = new Date(currYear,2,7);
		secondSundayOfMarch.setDate(7 +(7- secondSundayOfMarch.getDay()));

		let novemberForDateObejct = 10;
		let firstSundayOfNovember = this.firstSunday(novemberForDateObejct,currYear);
		let today = new Date();
		if(today > secondSundayOfMarch && today < firstSundayOfNovember) this.showDayLightSavingsText = true;

	},

	watch:{
		windows(){}
	},
	methods: {

		firstSunday(month,year) {
			let tempDate = new Date();
    		tempDate.setMonth(month);
    		tempDate.setYear(year);
    		tempDate.setDate(1);

    		let day = tempDate.getDay();
    		let toNextSun = day !== 0 ? 7 - day : 0;
    		tempDate.setDate(tempDate.getDate() + toNextSun);
    
    		return tempDate;
		},
		async makeSchedule() {
			
			// Check if session needs to be refreshed
			let success = await this.authenticationCheck(this);
			if (success.hasOwnProperty("ok") && !success.ok) {
				this.serverBusy = false;
				this.busyText = "";
				return false;
			}

			if(this.scheduleStartDate == null) {
				this.status.message = "You need to have a cycle start date to create a schedule";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				return;
			}
			if(this.cycleDurationNumber == null) {
				this.status.message = "You need to have a cycle duration number to create a schedule";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				return;
			}
			if(this.cycleDurationUnit == null) {
				this.status.message = "You need to have a cycle duration unit to create a schedule";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				return;
			}

			let body = {
				schedule: this.createSchedule(),
				limit: 4

			};
			let requestUrl = new URL("/api/v1/schedule/cycles", this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.adminState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let request = new Request(requestUrl.toString(), {
				method: "POST",
				body: JSON.stringify(body),
				headers: headerObj,
			});

			try {
				let response = await fetch(request);
				let dataJson = await response.json();
				this.cycleData = dataJson;
				this.calendarData = dataJson;

				this.schedule = body.schedule;

				document.getElementById("displaySchedule").value ="";
				this.eventBus.emit("createdSchedule",this.schedule);
				this.serializeData();
				this.calendarDataLoaded = true;
			}
			catch (e){
				console.log("this is the error", e);
				this.status.code = e;
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				return false;
			}
		},

		createSchedule() {
			const schedule = {
				windows:[]
			};
			let scheduleStartDate = new Date(document.getElementById("schedule-start-picker").value);
			schedule.scheduleStart = new Date(scheduleStartDate).toISOString();
			schedule.cycleDuration = this.getCycleDuration();

			schedule.windows = this.windows
			return schedule;
		},

		getCycleDuration() {
			const durationUnit = this.cycleDurationUnit;
			const durationValue = this.cycleDurationNumber;
			const durationObj = {};
			durationObj[durationUnit] = Number(durationValue);

			return durationObj;
		},


		closeScheduler() {
			this.eventBus.emit("closeSchedulerModal", this.serializedData);
		},


		removeWindow() {
			let windows = document.getElementById("created-windows");
			let currentIndex = 0;
			for(let opt of windows.options){
		
				if(opt.selected) this.windows.splice(currentIndex,1);
				currentIndex++;
		   	}
		},


		serializeData() {
			let seralizedSchedule = "Schedule Start: ";
            seralizedSchedule +=new Date(this.schedule.scheduleStart).toLocaleTimeString([], this.shortDateOptions) + "\n";

            seralizedSchedule += "Cycle Duration:  ";
			if( this.schedule.cycleDuration.Years != undefined) {
				seralizedSchedule +=  this.schedule.cycleDuration.Years + "yr"+ "\n";
			}
			if(this.schedule.cycleDuration.Months != undefined){
				 seralizedSchedule += this.schedule.cycleDuration.Months + "mo"+"\n";
			}
			if(this.schedule.cycleDuration.Days != undefined){
				 seralizedSchedule += this.schedule.cycleDuration.Days+ "day"+ "\n";
			}
			 
            seralizedSchedule  += "Windows: \n";

			for(let currWindow= 0; currWindow < this.schedule.windows.length; currWindow ++){
				seralizedSchedule += "Window Duration: ";

				if(this.schedule.windows[currWindow].windowDuration.months != 0){
					 seralizedSchedule += this.schedule.windows[currWindow].windowDuration.months +"mo +";
				}
				if(this.schedule.windows[currWindow].windowDuration.days != 0) {
					  seralizedSchedule += this.schedule.windows[currWindow].windowDuration.days +"day +";
				}
				if( this.schedule.windows[currWindow].windowDuration.hours != 0) {
					 seralizedSchedule += this.schedule.windows[currWindow].windowDuration.hours +"hr +";
				}
				if(this.schedule.windows[currWindow].windowDuration.minutes != 0) {
					 seralizedSchedule += this.schedule.windows[currWindow].windowDuration.minutes +"min";
				}

				if(seralizedSchedule[seralizedSchedule.length -1] == "+") seralizedSchedule = seralizedSchedule.slice(0,-1);

				seralizedSchedule+= "\nWindow Start: ";
				let seralizedWindowStart = "";
                if(this.schedule.windows[currWindow].windowStart.months != 0) {
					seralizedWindowStart += this.schedule.windows[currWindow].windowStart.months + "mo +";
				}
				if(this.schedule.windows[currWindow].windowStart.days != 0) {
					seralizedWindowStart += this.schedule.windows[currWindow].windowStart.days + "day +";
				}
				if(this.schedule.windows[currWindow].windowStart.hours != 0){
					seralizedWindowStart += this.schedule.windows[currWindow].windowStart.hours + "hr +";
				}
				if(this.schedule.windows[currWindow].windowStart.minutes != 0) {
					seralizedWindowStart += this.schedule.windows[currWindow].windowStart.minutes + "min";
				}
				
				if(seralizedWindowStart[seralizedWindowStart.length -1] == "+") seralizedWindowStart = seralizedWindowStart.slice(0,-1);
				if(seralizedWindowStart== "") seralizedWindowStart = "Started Immediately"

				seralizedWindowStart += "\n";
				seralizedSchedule += seralizedWindowStart;

			}	
			document.getElementById("displaySchedule").value += seralizedSchedule;
			this.serializedData = seralizedSchedule;
		}

	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.header {
	position: relative;
}

.scheduler {
	display: flex;
	position: relative;
	text-align: center;
	flex-direction: column;
	align-items: center;
	margin-top: 5%;
	
}

.schedule-width {
	width: 45px;
	height: 20px;
}

.scheduler-height {
	height: 250vh;
}

#create-modal-for-schedule {
	position: fixed;
	display: grid;
	height: 100vh;
	background-color: rgb(0 0 0 / 75%);
	-webkit-backdrop-filter: blur(6px);
	backdrop-filter: blur(6px);
	z-index: 1;
	overflow-y: auto;
}

#create-container-for-schedule {
	display: flex;
	flex-flow: column nowrap;
	position: relative;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: #222;
	color: #fff;
	width: 90%;
	margin: auto;
	padding: 30px;
	border-radius: 12px;
	text-align: center;
}

.curved-border {
	border-radius: 5px !important;
	-webkit-border-radius: 5px !important;
}

.extra-padding-text-fields {
	padding: 2px 15px;
}

.cycle-duration-width {
	width: 45px;
}

.calendar-section {
	display: flex;
	flex-direction: row;
}

option:checked {
	background: #5b88c0;
	color: white;
}

button {
	width: 135px;
	height: 30px;
}

hr {
	display: block;
	height: 1px;
	border: 0;
	border-top: 2px solid white;
	margin: 1em 0;
	padding: 0;
}

.required:before {
	content: "*";
	color: red;
}

.warning {
	color: yellow;
}

.windows-select {
	max-width: 80%;
	overflow-x: auto;
}

.disabled-input {
	pointer-events: none;
}

.windows-div {
	display: flex;
	justify-content: center;
	height: 35%;
}

.create-button {
	margin-top: 5vh;
}

.textarea-input {
	width: 60vw;
	height: 10vh;
}
@media (max-width: 768px) {
	#create-container-for-schedule {
		top: 1%;
	}
}

</style>